import request from 'Request'

const TcodesService = {
  async get({ patientIds }) {
    return request.post('/tcodes/list', { patientIds })
  }
}

export default TcodesService
